export default __webpack_public_path__ + "locales/sl/Translations.json?hash=49bf6bde74a2b594747b49a2c70ddbe6";